import request from '@/utils/request'


// 查询用户身体成分记录列表
export function listBodyCompositionRecord(query) {
  return request({
    url: '/joe/user-body-composition-record/list',
    method: 'get',
    params: query
  })
}

// 查询用户身体成分记录分页
export function pageBodyCompositionRecord(query) {
  return request({
    url: '/joe/user-body-composition-record/page',
    method: 'get',
    params: query
  })
}

// 查询用户身体成分记录详细
export function getBodyCompositionRecord(data) {
  return request({
    url: '/joe/user-body-composition-record/detail',
    method: 'get',
    params: data
  })
}

// 新增用户身体成分记录
export function addBodyCompositionRecord(data) {
  return request({
    url: '/joe/user-body-composition-record/add',
    method: 'post',
    data: data
  })
}

// 修改用户身体成分记录
export function updateBodyCompositionRecord(data) {
  return request({
    url: '/joe/user-body-composition-record/edit',
    method: 'post',
    data: data
  })
}

// 删除用户身体成分记录
export function delBodyCompositionRecord(data) {
  return request({
    url: '/joe/user-body-composition-record/delete',
    method: 'post',
    data: data
  })
}
